module.exports = __webpack_public_path__ + "static/Ainoa Molina_cv_2020-6224b3ff79173816ce437b4c036109cc.pdf";